import { initializeApp } from 'firebase/app'
import { FIREBASE_CONFIG } from '../config'

let app = null

export const getApp = () => {
  if (app === null) {
    // Initialize Firebase if not already
    app = initializeApp(FIREBASE_CONFIG)
  }

  return app
}
